import React from 'react';
import parsePhoneNumberFromString from "libphonenumber-js";

interface Props {
    countryCode: string;
    phoneNumber?: string;
}

export const getFormattedPhoneNumber = (countryCode: string, phoneNumber?: string) => {
    if (!phoneNumber) return "";

    const fullPhoneNumber = phoneNumber.length > 10 ? `+${phoneNumber}` : phoneNumber;
    const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);

    if (!parsedPhoneNumber) return phoneNumber;

    if (countryCode === "PL") {
        return parsedPhoneNumber.formatNational();
    } else {
        return parsedPhoneNumber.formatInternational();
    }
}

export const FormattedPhoneNumber = ({phoneNumber, countryCode}: Props) => {
    if (!phoneNumber) return <></>;

    return (<>{getFormattedPhoneNumber(countryCode, phoneNumber)}</>);
}